import axios, { fetcher, endpoints } from 'src/utils/axios';

export async function updateCompanyProfile(apiData) {
  const URL = endpoints.profile.company;
  try {
    const { data } = await axios.put(URL, apiData);
    return data;
  } catch (error) {
    console.error('Error updating role:', error);
    throw error;
  }
}

export async function updateUserProfile(apiData) {
  const URL = endpoints.profile.user;
  try {
    const { data } = await axios.put(URL, apiData);
    return data;
  } catch (error) {
    console.error('Error updating role:', error);
    throw error;
  }
}
